
export const generateRequestBody = (initialSelectedAccounts, selectedAccounts, accounts) => {
  const assignedAccounts = [];
  const unassignedAccounts = {
    grandfatherClientNumbers: [],
    parentAccountNumbers: [],
    childAccounts: []
  };

  const aAccounts = selectedAccounts.filter(contractNumber => {
    const account = accounts.find(item => item.contractNumber === contractNumber);
    return account && account.level === 'A';
  });

  const isAAccountGP = aAccounts.length > 0;

  if (isAAccountGP) {
    aAccounts.forEach(aAccount => {
      const assignedAccount = {
        grandfatherClientNumber: aAccount,
        level: 'A',
        assignedAccountIds: []
      };
  
      const bAccounts = selectedAccounts
        .filter(contractNumber => {
          const account = accounts.find(item => item.contractNumber === contractNumber);
          return account && account.level === 'B' && account.parent === aAccount;
        });
  
      bAccounts.forEach(bAccount => {
        const assignedAccountId = {
          parentAccountNumber: bAccount,
          // accountName: accounts.find(item => item.contractNumber === bAccount).contractName,
          level: 'B',
          accounts: []
        };
  
        const cAccounts = selectedAccounts
          .filter(contractNumber => {
            const account = accounts.find(item => item.contractNumber === contractNumber);
            return account && account.level === 'C' && account.parent === bAccount;
          });
  
        cAccounts.forEach(cAccount => {
          const cAccountDetails = accounts.find(item => item.contractNumber === cAccount);
          assignedAccountId.accounts.push({
            accountType: cAccountDetails.clientType,
            accountNumber: cAccountDetails.contractNumber,
            // accountName: cAccountDetails.contractName,
            level: 'C'
          });
        });
  
        assignedAccount.assignedAccountIds.push(assignedAccountId);
      });
  
      assignedAccounts.push(assignedAccount);
    });
  } else {
    const bAccounts = selectedAccounts.filter(contractNumber => {
      const account = accounts.find(item => item.contractNumber === contractNumber);
      return account && account.level === 'B';
    });

    bAccounts.forEach(bAccount => {
      const assignedAccount = {
        grandfatherClientNumber: bAccount,
        level: 'B',
        assignedAccountIds: []
      };

      const cAccounts = selectedAccounts
        .filter(contractNumber => {
          const account = accounts.find(item => item.contractNumber === contractNumber);
          return account && account.level === 'C' && account.parent === bAccount;
        });

      cAccounts.forEach(cAccount => {
        const cAccountDetails = accounts.find(item => item.contractNumber === cAccount);
        assignedAccount.assignedAccountIds.push({
          parentAccountNumber: cAccountDetails.contractNumber,
          // accountName: cAccountDetails.contractName,
          level: 'C',
          accounts: [],
        });
      });

      assignedAccounts.push(assignedAccount);
    });
  }

  unassignedAccounts.grandfatherClientNumbers = initialSelectedAccounts
    .filter(contractNumber => !selectedAccounts.includes(contractNumber))
    .filter(contractNumber => {
      const account = accounts.find(item => item.contractNumber === contractNumber);
      return account && (isAAccountGP ? account.level === 'A' : account.level === 'B');
    });

  unassignedAccounts.parentAccountNumbers = initialSelectedAccounts
    .filter(contractNumber => !selectedAccounts.includes(contractNumber))
    .filter(contractNumber => {
      const account = accounts.find(item => item.contractNumber === contractNumber);
      return account && (isAAccountGP ? account.level === 'B' : account.level === 'C');
    });

  unassignedAccounts.childAccounts = initialSelectedAccounts
    .filter(contractNumber => !selectedAccounts.includes(contractNumber))
    .filter(contractNumber => {
      const account = accounts.find(item => item.contractNumber === contractNumber);
      return account && isAAccountGP && account.level === 'C';
    });

  return {
    assignedAccounts: assignedAccounts.slice(0, 1),
    unassignedAccounts: unassignedAccounts
  };
};
